import React from 'react'

import type { TUsePopoverReturn } from './usePopover'

const PopoverContext = React.createContext<TUsePopoverReturn | undefined>(undefined)

export const PopoverProvider = PopoverContext.Provider

export const usePopoverContext = () => {
  const context = React.useContext(PopoverContext)

  if (!context) {
    throw new Error('usePopoverContext must be used within a PopoverProvider')
  }

  return context
}
